import React, { useState, useEffect, useMemo } from 'react'

import { Modal } from '../../../__generated__/api'
import { useModals } from '../../../common/hooks/useModals'
import AppointmentNoteModal, {
  AppointmentNoteConfig,
  AppointmentNoteType,
} from '../../search/components/AppointmentNoteModal'

interface Props {
  onContinue(): void
  onClose(): void
  modalType: Modal['type']
}

const GenericModalWrapper: React.FC<Props> = ({ onContinue, onClose, modalType }) => {
  const [appointmentNote, setAppointmentNote] = useState<AppointmentNoteConfig | null>(null)
  const { modals, getModal } = useModals()

  const modal = useMemo(() => {
    const modalData = modals.find((m) => m.type === modalType)
    return getModal(modalData?.id ?? '')
  }, [getModal, modalType, modals])

  useEffect(() => {
    setAppointmentNote({
      type: AppointmentNoteType.CUSTOM,
      modal: modal,
      onContinue: onContinue,
      onClose: onClose,
      onDigitalClinic: () => null, // Not needed yet
    })
  }, [modal, onContinue, onClose])

  return <AppointmentNoteModal note={appointmentNote} />
}

export default GenericModalWrapper
